import { render } from "./3DViewerCUSTOM.vue?vue&type=template&id=194db050&scoped=true"
import script from "./3DViewerCUSTOM.vue?vue&type=script&lang=js"
export * from "./3DViewerCUSTOM.vue?vue&type=script&lang=js"

import "./3DViewerCUSTOM.vue?vue&type=style&index=0&id=194db050&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-194db050"]])

export default __exports__